module.exports = __webpack_public_path__ + "static/media/newyork-highline.548e448e.jpg";